/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useLayout } from '../core'

const Footer: FC = () => {
  const { classes } = useLayout()
  return (
    <div className='footer py-1 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-center`}
      >
        {/* begin::Copyright */}
        <div className='text-dark order-2 order-md-1'>
          <span className='text-muted fw-bold fs-9'>{new Date().getFullYear()} &copy; </span>
          <a
            href='https://rulezero.com/'
            className='text-gray-800 text-hover-primary fs-9'
            target='_blank'
            rel='noreferrer'
          >
            Rulezero
          </a>
          <span className='text-muted fs-9'> | All Rights Reserved</span>
        </div>
        {/* end::Copyright */}
      </div>
      {/* end::Container */}
    </div>
  )
}

export { Footer }
